import { USER_PERMISSIONS } from '@/constants';

import { authMixin } from '@/mixins/auth';

export const permissionsTechnicalExploitationPbehaviorMixin = {
  mixins: [authMixin],
  computed: {
    hasCreateAnyPbehaviorAccess() {
      return this.checkCreateAccess(USER_PERMISSIONS.technical.exploitation.pbehavior);
    },

    hasReadAnyPbehaviorAccess() {
      return this.checkReadAccess(USER_PERMISSIONS.technical.exploitation.pbehavior);
    },

    hasUpdateAnyPbehaviorAccess() {
      return this.checkUpdateAccess(USER_PERMISSIONS.technical.exploitation.pbehavior);
    },

    hasDeleteAnyPbehaviorAccess() {
      return this.checkDeleteAccess(USER_PERMISSIONS.technical.exploitation.pbehavior);
    },
  },
};
